// extracted by mini-css-extract-plugin
export default {"burgerMenu":"BurgerMenu_burgerMenu__oNLJg","burgerMenu_open":"BurgerMenu_burgerMenu_open__OvNci","links":"BurgerMenu_links__7nLLf","link":"BurgerMenu_link__8S-JO"};